export default __webpack_public_path__ + "static/media/category_checked.0b31c07d.svg";